import { computed } from 'vue';
import { useAvailability } from '../../../composables/useAvailability';
import { useInitSize } from './useSize';
import ParserPDP from '../parsers/SizeParser';

/**
 *
 * @param {Size} size
 * @param {Availability} availability
 * @returns {BaseSize}
 */
function toBaseSize(size, availability) {
  return {
    id: size.id,
    name: size.name,
    displayName: size.displayName,
    available: availability[size.id],
  };
}

/**
 *
 * @param {Array<Size>} sizes
 * @returns {boolean}
 */
export function showSizeDropdown(sizes = []) {
  const sizesCount = sizes.length;
  const longestNameLength = sizes
    .map((size) => size.displayName.length)
    .reduce((acc, current) => Math.max(current, acc), 0);

  return (
    ((longestNameLength <= 3 && sizesCount > 24)
      || (longestNameLength > 3 && longestNameLength <= 5 && sizesCount > 20)
      || (longestNameLength > 5 && longestNameLength <= 7 && sizesCount > 16)
      || longestNameLength > 7)
    && sizesCount > 1
  );
}

/**
 *
 * @param {{id: string, product: Product }} param0
 * @returns {import('vue').ComputedRef<SizeProps>}
 */
export function useInitSizePDP({ id, product }) {
  const parsedData = ParserPDP(product);
  useInitSize({ id, data: parsedData });

  const { size: availability } = useAvailability(id);

  return computed(() => ({
    sizes: parsedData.sizeArray.map((size) => toBaseSize(size, availability.value)),
    isSizeDropdown: showSizeDropdown(parsedData.sizeArray),
  }));
}

export default useInitSizePDP;
